import { useEffect } from 'react';
import { useStore } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@/app/hooks';
import type { RootState } from '@/app/store';
import SplashScreen from '@/components/common/SplashScreen';
import { openBillingRegularization } from '@/features/billing/billingRegularizationFlow';
import {
  OPEN_UNPAID_MODAL_STATE,
  parseRegularizationWorkspaceId,
} from '@/lib/billingRegularization';

/** Cible du bouton des mails de relance : ouvre le paiement de l'impayé du workspace désigné. */
export default function BillingRegularizationPage() {
  const dispatch = useAppDispatch();
  const store = useStore<RootState>();
  const navigate = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    const workspaceId = parseRegularizationWorkspaceId(search);
    if (workspaceId === null) {
      navigate('/', { replace: true });
      return;
    }

    let cancelled = false;
    void openBillingRegularization({ dispatch, getState: store.getState, workspaceId }).then(
      (target) => {
        if (cancelled) return;
        if (target === 'billing') {
          navigate('/billing', { replace: true, state: { [OPEN_UNPAID_MODAL_STATE]: true } });
        } else {
          navigate('/', { replace: true });
        }
      },
    );
    return () => {
      cancelled = true;
    };
  }, [search, dispatch, navigate, store]);

  return <SplashScreen />;
}
